import styled from 'styled-components';
import media from 'styled-media-query';
import Box from '@firsttable/web-components/atoms/Box';
import { breakpointsObject as bp } from '@firsttable/web-theme';

const searchBarSize = 52;

const SearchBtn = styled(Box)`
  top: 0;
  left: -1px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: ${searchBarSize}px;
  z-index: 1;
  ${media.greaterThan(bp.s)`
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -${searchBarSize / 2}px;
    justify-content: flex-end;
  `};
`;
const SearchBtnText = styled(Box)`
  top: 0;
  left: 40px;
  display: none;
  align-items: center;
  height: ${searchBarSize}px;
  ${media.greaterThan(bp.m)`
    display: flex;
    position: absolute;
    top: 50%;
    left: 52px;
    margin-top: -${searchBarSize / 2}px;
  `};
`;

interface RegionFilterWrapperProps {
  height: any;
}

// todo need to use any here. Not sure how to fix this TS error
const breakpoint: any = {
  large: '1160px',
};

const RegionFilterWrapper = styled.div<RegionFilterWrapperProps>`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 5px;
  ${media.greaterThan(breakpoint.large)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    justify-content: center;
    height: ${(props: any) => props.height.desktop};
  `};
`;
const SearchBarWrapper = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  z-index: 1;
`;

export { SearchBtn, SearchBtnText, RegionFilterWrapper, SearchBarWrapper };
